export default {
  zoneImportFile: {
    section: {
      partitionType: '选择分区类型',
      duplicate: '重复数据处理',
      instructions: '导入说明',
      uploadFile: '上传文件',
      validateResult: '校验结果',
      importStats: '导入统计',
      errorDetails: '错误详情',
    },
    partitionType: {
      postCode: '邮编',
      city: '城市',
      country: '国家',
      byPostCode: '按邮编分区',
      byCity: '按城市分区',
      byCountry: '按国家分区',
    },
    postCodeMode: {
      normal: '普通邮编',
      combination: '组合邮编',
    },
    importType: {
      overwrite: '覆盖现有数据',
      clearAndImport: '清空数据重新导入',
    },
    instruction: {
      downloadFirst: '请先下载导入模板，按照模板格式填写数据后再上传',
      fileSupport: '支持文件格式：.xlsx、.xls，文件大小不超过10MB',
      autoValidate: '系统将自动校验数据格式，错误数据不会被导入，可下载错误报告查看详情',
      duplicateWarning: '数据重复时，导入的新数据将覆盖原有数据，请谨慎操作',
    },
    upload: {
      dragText: '拖拽文件到此处上传',
      clickToChoose: '或者点击下方按钮选择文件',
    },
    button: {
      downloadTemplate: '下载模板',
      chooseFile: '选择文件',
      downloadErrorReport: '下载错误报告',
      back: '返回',
      startImport: '开始导入',
      importing: '导入中...',
      exportErrorData: '导出错误数据',
      reUpload: '继续导入',
      backToZoneList: '返回区域列表',
    },
    stats: {
      total: '总条数：',
      passed: '校验通过：',
      failed: '校验失败：',
      totalProcessed: '总处理条数',
      importSuccess: '导入成功',
      importFailed: '导入失败',
    },
    table: {
      rowNumber: '序号',
      partitionType: '分区类型',
      country: '国家',
      state: '省/州',
      city: '城市',
      startPostalCode: '起始邮编',
      endPostalCode: '结束邮编',
      zone: '分区',
      errorReason: '错误原因',
    },
    done: {
      title: '导入完成',
      titleWithError: '导入完成，存在失败数据',
      textWithFailed: '本次共处理 {total} 条数据，成功 {passed} 条，失败 {failed} 条',
      textSuccess: '区域数据已导入系统，本次共处理 {total} 条数据',
    },
    note: {
      validating: '正在根据分区类型自动校验文件...',
      localError: '文件数据校验失败，请下载错误报告修正后重新上传',
      passed: '校验通过，可开始导入',
      partial: '系统已自动过滤校验失败的数据，仅导入校验通过的数据',
    },
    message: {
      invalidFileType: '仅支持 .xlsx、.xls 格式文件',
      fileTooLarge: '文件大小不能超过 10MB',
      oneFileOnly: '仅支持上传一个文件，请先删除已有文件',
      chooseFileFirst: '请先选择文件',
      parseFailed: '文件解析失败，请检查文件后重新上传',
      validateFirst: '请先选择文件并完成校验',
      fixLocalError: '文件数据校验失败，请修正后重新上传',
      emptyFile: '文件数据为空，请重新上传',
    },
    error: {
      duplicatePostalCodeRangeErrors: [
        '导入失败：文件中存在重复的分区明细行（数据完全相同），请删除重复行后重新导入',
        '导入失败：表格中的“邮编范围”存在重复，请检查并确保每个邮编范围唯一后重新导入。',
        '字母数字邮编不支持范围，起始邮编和结束邮编必须相同。',
        '邮编格式无效',
      ],
    },
    validation: {
      headerField: '表头',
      headerRequiredColumns: '请按模板填写列：{columns}',
      requiredSuffix: '不能为空',
      zoneFormat: 'Zone只能输入英文、数字或空格，且不能以空格开头或结尾',
      countryFormat: 'Country必须为有效的国家二字码（如CN、US）',
      stateFormat: 'State只能输入中文、英文或空格',
      cityFormat: 'City只能输入中文、英文、空格或逗号',
      lettersNumbersSuffix: '只能输入字母或数字',
      combinationPostalCodeFormat: 'Postal Code只能输入整数数字、逗号、横杠或空格，且不能以空格开头或结尾',
      postalCodeRange: 'End Postal Code不能小于Start Postal Code',
    },
    report: {
      importErrorFile: '导入错误数据_',
      localErrorFile: '校验错误报告_',
      validationStatus: '校验状态',
      validationPassed: '校验通过',
      separator: '、',
      messageSeparator: '；',
      fieldSeparator: '：',
    },
  },
};
